import { Services } from "appworks/services/services";
import { TranslationsService } from "appworks/services/translations/translations-service";
import { BetBarComponent } from "slotworks/components/betbar/bet-bar-component";

export class FowlBetBarComponent extends BetBarComponent {
    protected updateTexts(): void {
        super.updateTexts();

        const totalWinText = this.layer.getText("total_win_value");
        if (totalWinText?.text.length > 0) {
            totalWinText.text = `${Services.get(TranslationsService).get("win")}: ${totalWinText.text}`;
        }
    }
}
